import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/products-services', label: 'Products & Services' },
    { path: '/return-policy', label: 'Return Policy' },
    { path: '/privacy-policy', label: 'Privacy Policy' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img
              src="https://public.readdy.ai/ai/img_res/900448bc-e124-4164-bbae-25c5d6a7b547.png"
              alt="Sodrel Logistics"
              className="h-12 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-[#FF8C42]'
                    : isScrolled
                    ? 'text-[#2A2A2A] hover:text-[#FF8C42]'
                    : 'text-white hover:text-[#FF8C42]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:+13172460584"
              className="bg-[#FF8C42] text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-[#D4693A] transition-all duration-300 whitespace-nowrap"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;